import React from "react";
import { Container, Grid, Paper, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles({
  root: {
    marginBottom: "10vh",
  },
});

export default function Welcome() {
  const classes = useStyles();

  return (
    <Container maxWidth="md" className={classes.root}>
      <Grid container>
        {/* <Grid item xs={12} sm={3}></Grid> */}
        <Grid item xs={12} sm={12}>
          <Paper style={{textAlign: "center", padding: 20}}>
            <Typography variant="h1" component="h1" className={classes.title}>
              Solarpunk
            </Typography>
            <Typography variant="h4" component="div" className={classes.title}>
              Mollit tempor potenti ratione class accusamus? Lobortis ac hac
              quos volutpat? Felis, autem? Aliquid sollicitudin voluptates purus
              praesent, eiusmod modi enim quam? Condimentum laboriosam!
            </Typography>
          </Paper>
        </Grid>
      </Grid>
    </Container>
  );
}
